// extracted by mini-css-extract-plugin
export default {"container":"DownloadBlock_container__PqJ2s","title":"DownloadBlock_title__TxVMu","icon":"DownloadBlock_icon__8wQMv","linksWrapper":"DownloadBlock_linksWrapper__GREnu"};